import Vue from "vue";
import VueRouter from "vue-router";

import HomeTab from "@/views/Home";
import PropertiesTab from "@/views/Properties";
import PropertyDetails from "@/views/PropertyDetails";
import AboutUsTab from "@/views/AboutUs";
import ContactUsTab from "@/views/ContactUs";
import PrivacyPolicy from "@/views/PrivacyPolicy";
import FAQs from "@/views/FAQs";
import OutsideAdvertise from "@/views/OutsideAdvertise";
import WeSpeakGerman from "@/views/WeSpeakGerman";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeTab,
  },
  {
    path: "/properties",
    name: "Properties",
    component: PropertiesTab,
  },
  {
    path: "/properties/view/:id",
    name: "PropertyDetails",
    component: PropertyDetails,
    props: true,
  },
  {
    path: "/about-us",
    name: "AboutUs",
    component: AboutUsTab,
  },
  {
    path: "/contact-us",
    name: "ContactUs",
    component: ContactUsTab,
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
  },
  {
    path: "/faqs",
    name: "FAQs",
    component: FAQs,
  },
  {
    path: "/we-speak-german",
    name: "WeSpeakGerman",
    component: WeSpeakGerman,
  },
  {
    path: "/outside-advertise/view/:id",
    name: "OutsideAdvertise",
    component: OutsideAdvertise,
    props: true,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
